import SectionCard from './SectionCard';

export default SectionCard;
